import { render, staticRenderFns } from "./OrganisationFilters.vue?vue&type=template&id=96ca5b0e&"
import script from "./OrganisationFilters.vue?vue&type=script&lang=ts&"
export * from "./OrganisationFilters.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports